import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatHint } from '@angular/material/form-field';

import { ReadSectionEmptyComponent } from './readonly/read-section-empty.component';
import { readSectionState, type ReadSectionState } from './readonly/read-section.util';

@Component({
  selector: 'formly-field-group',
  template: `
    <!-- An empty section inside an empty section says nothing: the outer one already does. -->
    @if (readState !== 'nested-empty') {
      <div>
        @if (field.props.label) {
          <h3 class="mb-2">{{ field.props.label }}</h3>
        }
        @for (fieldItem of field.fieldGroup; track $index) {
          <formly-field [field]="fieldItem"></formly-field>
        }
        @if (readState === 'empty') {
          <!-- Read mode hid every answer here (#21239): words instead of a bare heading, see
               read-section.util.ts for the reasoning. -->
          <dd-read-section-empty />
        }
        <!-- Fill-in help belongs to editing; the read view does not show it (#21239). -->
        @if (field.props.description && readState === 'edit') {
          <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
        }
      </div>
    }
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
  `,
  imports: [FormlyModule, MatTabsModule, MatHint, ReadSectionEmptyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldGroup extends FieldType {
  /** Evaluated per render: the answers' `hide` flags are only resolved once Formly has built them. */
  get readState(): ReadSectionState {
    return readSectionState(this.field);
  }
}
